import { getConfig } from "@util/config";

export const OLD_WATA_URL: string = getConfig("OLD_WATA_URL");
